<div #refModalTrigger><ng-content select="[trigger]"></ng-content></div>
@if ((refModalTrigger.children.length == 0)) {
  <div>
    <button nz-button nzType="primary" (click)="showModal(null)">
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>{{triggerTitle}}</span>
    </button>
  </div>
}
<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1920"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <app-add-edit-article-form
      #form
      [editObject]="object"
      (formFinished)="onFormFinished($event)"
      (articleCreated)="articleCreated.emit($event)"
      (mhdChanged)="mhdChanged.emit()"
    ></app-add-edit-article-form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Abbrechen</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Speichern</button>
  </ng-template>
</nz-modal>

<app-add-article-label-modal
  #addArticleLabelModal
  (refresh)="onEtikettenRefresh()"
  (openOwnBrand)="onOpenOwnBrand($event)"
/>
<app-add-edit-round-label-modal
  #addEditRoundLabelModal
  (refresh)="onEtikettenRefresh()"
/>
<app-edit-label-modal
  #editLabelModal
  (reloadList)="onEtikettenRefresh()"
></app-edit-label-modal>
